import { AxiosError } from "axios";
import { CartError, CartOperation } from "./types";

export function classifyError(
  error: unknown,
  operation?: CartOperation
): CartError {
  if (error instanceof AxiosError) {
    const status = error.response?.status;

    if (!status) {
      return {
        type: "NETWORK",
        message: error.message,
        operation,
        recoverable: true,
        userMessage:
          "Sem conexão por aqui. Assim que a internet voltar, a gente tenta de novo.",
      };
    }

    switch (status) {
      case 400:
        return {
          type: "VALIDATION",
          message: error.response?.data?.message || "Validation error",
          operation,
          recoverable: false,
          userMessage:
            "Esse item não passou na validação. Remova e adicione de novo.",
        };

      case 401:
      case 403:
        return {
          type: "AUTH",
          message: "Unauthorized",
          operation,
          recoverable: false,
          userMessage: "Sua sessão expirou. Entre de novo, rapidinho.",
        };

      case 404:
        return {
          type: "NOT_FOUND",
          message: "Item not found",
          operation,
          recoverable: false,
          userMessage: "Esse item não está mais disponível.",
        };

      case 409:
        return {
          type: "CONFLICT",
          message: "Concurrent modification",
          operation,
          recoverable: true,
          userMessage:
            "Sua sacola foi atualizada em outro lugar. Sincronizando...",
        };

      case 429:
        return {
          type: "RATE_LIMIT",
          message: "Rate limited",
          operation,
          recoverable: true,
          userMessage: "",
        };

      default:
        if (status >= 500) {
          return {
            type: "SERVER",
            message: `Server error: ${status}`,
            operation,
            recoverable: true,
            userMessage: "O servidor deu uma engasgada. Vamos tentar de novo.",
          };
        }
    }
  }

  if (error instanceof TypeError && error.message.includes("fetch")) {
    return {
      type: "NETWORK",
      message: error.message,
      operation,
      recoverable: true,
      userMessage:
        "Sem conexão por aqui. Assim que a internet voltar, a gente tenta de novo.",
    };
  }

  return {
    type: "UNKNOWN",
    message: String(error),
    operation,
    recoverable: false,
    userMessage: "Algo deu errado por aqui. Tente de novo.",
  };
}

export function shouldRetry(error: CartError): boolean {
  return error.recoverable;
}

export function isAuthError(error: CartError): boolean {
  return error.type === "AUTH";
}

export function isNetworkError(error: CartError): boolean {
  return error.type === "NETWORK";
}

export function isServerError(error: CartError): boolean {
  return error.type === "SERVER";
}

export function isValidationError(error: CartError): boolean {
  return error.type === "VALIDATION";
}
